export const Types = {
  SET_VALVE_TO_WORK_REQUEST: '@valves/SET_VALVE_TO_WORK_REQUEST',
  SET_VALVE_TO_WORK_SUCCESS: '@valves/SET_VALVE_TO_WORK_SUCCESS',
  SET_VALVE_TO_WORK_FAILURE: '@valves/SET_VALVE_TO_WORK_FAILURE',

  VALVE_UPDATE_REQUEST: '@valves/VALVE_UPDATE_REQUEST',
  VALVE_UPDATE_SUCCESS: '@valves/VALVE_UPDATE_SUCCESS',
  VALVE_UPDATE_FAILURE: '@valves/VALVE_UPDATE_FAILURE',

  VALVE_DELETE_REQUEST: '@valves/VALVE_DELETE_REQUEST',
  VALVE_DELETE_SUCCESS: '@valves/VALVE_DELETE_SUCCESS',
  VALVE_DELETE_FAILURE: '@valves/VALVE_DELETE_FAILURE',
};

/**
 *
 */
export function setValveCalibrationToWorkRequest(payload) {
  return {
    type: Types.SET_VALVE_TO_WORK_REQUEST,
    payload,
  };
}

export function setValveCalibrationToWorkSuccess(payload) {
  return {
    type: Types.SET_VALVE_TO_WORK_SUCCESS,
    payload,
  };
}

export function setValveCalibrationToWorkFailure() {
  return {
    type: Types.SET_VALVE_TO_WORK_FAILURE,
  };
}
/**
 *
 */
export function updateValveCalibrationRequest(payload) {
  return {
    type: Types.VALVE_UPDATE_REQUEST,
    payload,
  };
}

export function updateValveCalibrationSuccess(payload) {
  return {
    type: Types.VALVE_UPDATE_SUCCESS,
    payload,
  };
}

export function updateValveCalibrationFailure() {
  return {
    type: Types.VALVE_UPDATE_FAILURE,
  };
}
/**
 *
 */
export function deleteValveCalibrationRequest(payload) {
  return {
    type: Types.VALVE_DELETE_REQUEST,
    payload,
  };
}

export function deleteValveCalibrationSuccess(payload) {
  return {
    type: Types.VALVE_DELETE_SUCCESS,
    payload,
  };
}

export function deleteValveCalibrationFailure() {
  return {
    type: Types.VALVE_DELETE_FAILURE,
  };
}
